<template>
  <div class="elr-card-header" v-if="image">
    <figure class="elr-card-full-image">
      <router-link v-if="url" :to="url">
        <img class="elr-card-image" :src="image" :alt="item.name">
      </router-link>
      <img v-else class="elr-card-image" :src="image" :alt="item.name">
    </figure>
  </div>
</template>

<script>
export default {
  name: 'CardHeader',
  props: {
    item: {
      type: Object,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    url: {
      type: String,
    },
    image: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.elr-card-full-image {
  max-height: 280px;
  overflow: hidden;

  img {
    max-width: 100%;
  }
}
</style>

